<template>
  <Layout>
    <h1 class="text-center">Not Found.</h1>
    <p class="text-center">We couldn't find the page you were looking for.</p>
  </Layout>
</template>

<script>
import Layout from "@/Layout/Authenticated/Layout.vue";

export default {
  name: "NotFound",
  components: {
    Layout,
  },
};
</script>

<style></style>
